import styled from 'styled-components';

export const PasswordPopupContainer = styled.div`
  padding: 15px;
  background: #19213e;
  border-radius: 8px;

  & > div {
    display: flex;
    justify-content: space-around;
    margin: 10px 0px;
  }
`